import cx from 'classnames';
import { forwardRef } from 'react';

function Button(
  {
    active = false,
    children,
    className,
    component: Component = 'button',
    color,
    icon,
    size,
    type = 'button',
    ...props
  },
  ref
) {
  return (
    <Component
      ref={ref}
      className={cx(
        'inline-flex items-center justify-center gap-2 rounded-lg border border-transparent text-center uppercase transition focus:outline-none',
        {
          'bg-primary-500 text-white hover:border-primary-500 hover:bg-white hover:fill-primary-500 hover:text-primary-500 focus:ring-2 focus:ring-primary-200':
            color === 'primary',
          'border-primary-500 bg-transparent text-primary-500 hover:bg-primary-500 hover:fill-primary-500 hover:text-white focus:ring-2 focus:ring-primary-200':
            color === 'outline',
          'border-white text-white hover:bg-white hover:text-primary-600 focus:ring-2 focus:ring-white':
            color === 'inverted',
          'px-4 py-2': !size,
          '!bg-primary-500 !text-white': active,
        },
        className
      )}
      type={type}
      {...props}
    >
      {children}
      {icon && icon}
    </Component>
  );
}
export default forwardRef(Button);
